import { createSlice } from '@reduxjs/toolkit'

import Web3Service from 'primsell-shared-layer/core/services/web3'

import { IBuyerReducers, IBuyerState } from './buyer.types'

const initialState: IBuyerState = {
  address: '' as `0x${string}`,
  loading: false,
  firstName: '',
  lastName: '',
  email: '',
  error: '',
}

const { actions, reducer } = createSlice<IBuyerState, IBuyerReducers, 'buyer'>({
  name: 'buyer',
  initialState,
  reducers: {
    getBuyerDataRequest: (state, { payload }) => {
      state.address = payload.address
      state.loading = true
      state.error = ''
    },
    getBuyerDataSuccess: (state, { payload }) => {
      state.loading = false
      state.firstName = payload.firstName
      state.lastName = payload.lastName
      state.email = payload.email
    },
    getBuyerDataFailed: (state, { payload }) => {
      state.loading = false
      state.error = payload
    },
    clearBuyerData: (state) => {
      state.address = '' as `0x${string}`
      state.firstName = ''
      state.lastName = ''
      state.email = ''
      state.error = ''
      state.loading = false
      Web3Service.clearConnection()
    },
  },
})

export { actions as BuyerActions }

export { reducer as buyerReducer }
